/**
 * A short, eased camera pan — for the editor moving the room on the planner's
 * behalf (a sheet slid up over the table they tapped), where a jump would read
 * as the room lurching. Any touch on the canvas stops it: the planner's own
 * gesture always wins.
 */

import { useViewStore } from '../store/viewStore'

let frame = 0

export function glideCamera(to: { x: number; y: number }, duration = 240): void {
  stopGlide()
  const from = useViewStore.getState()
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reduce || (Math.abs(to.x - from.x) < 1 && Math.abs(to.y - from.y) < 1)) {
    useViewStore.getState().setCamera(to)
    return
  }
  const start = performance.now()
  const step = (now: number) => {
    const t = Math.min(1, (now - start) / duration)
    const eased = 1 - (1 - t) ** 3
    useViewStore.getState().setCamera({
      x: from.x + (to.x - from.x) * eased,
      y: from.y + (to.y - from.y) * eased,
    })
    frame = t < 1 ? requestAnimationFrame(step) : 0
  }
  frame = requestAnimationFrame(step)
}

export function stopGlide(): void {
  if (frame) cancelAnimationFrame(frame)
  frame = 0
}
